module.exports = __webpack_public_path__ + "static/media/ois2.3cdbb761.png";